//hamburger
const toggleGlobalNav = () => {

  const hamburger = document.getElementById('js-hamburger');
  const hamburgerClone = document.getElementById('js-hamburger-clone');

  if (!hamburger || !hamburgerClone) return;

  const body = document.body;

  hamburger.addEventListener('click', () => {
    body.classList.toggle('is-gnav-active');
  });
  hamburgerClone.addEventListener('click', () => {

    body.classList.toggle('is-clone-gnav-active');
  });
}
toggleGlobalNav();

//sidebar sp
const sidebarToggle = () => {
  const targets = document.querySelectorAll('.blog-sidebar:not(:first-child)');
  if (!targets) return;

  const removeClass = () => {
    Array.from(targets).forEach((target) => {
      if (target.classList.contains('is-active') === true) {
        target.classList.remove('is-active');
      }
    });
  }

  Array.from(targets).forEach((target) => {
    target.addEventListener('click', () => {

      if (target.classList.contains('is-active') === true) {
        target.classList.remove('is-active');
      } else {
        removeClass();
        target.classList.add('is-active');
      }
    });
  });
}

if (window.matchMedia("(max-width: 1200px)").matches) {
  sidebarToggle();
}

const copyURL = () => {
  const copyBtn = document.getElementsByClassName('p-blog-post-sns__link');
  if (!copyBtn) return;

  [...copyBtn].forEach(e => {
    e.addEventListener('click', () => {
      const url = location.href;
      const decodeUrl = decodeURI(url);
      navigator.clipboard.writeText(decodeUrl);
    })
  })
}
copyURL();


const fixedHeader = () => {
  const cloneHeader = document.getElementById('header-clone');
  const container = document.getElementById('container');

  if (!cloneHeader || !container) return;

  const trigger = document.getElementById('js-header-trigger');

  const observer = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        cloneHeader.classList.remove('is-show');
      } else {
        cloneHeader.classList.add('is-show');
      }
    }
  }, {});
  observer.observe(trigger);
}
fixedHeader();
